import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useMediaQuery, CircularProgress, Snackbar, Alert } from '@mui/material';
import { getDecryptedRefreshToken } from '../../LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../../ApiServices/ApiServices';
import ProviderSidebar from '../../../Container/Provider/ProviderSidebar/ProviderSidebar';
import CryptoJS from 'crypto-js';
import ProviderDashboard from '../../../Components/ProviderComponents/ProviderDashboard/ProviderDashboard';
import PatientTabs from '../../../Components/ProviderComponents/Patients/PatientTabs';
import ProviderRouteAccess from './ProviderRouteAccess';
import AllAppointments from '../../../Components/ProviderComponents/AllAppointments/AllAppointments';
import DoctorDetailsTabs from '../../../Components/AdminUserComponents/DoctorsHandling/DoctorDetailsTabs';
import ProviderAvailableSchedule from '../../../Components/AdminUserComponents/ProviderSchedule/ProviderAvailableSchedule';
import PersonalSchedule from '../../../Components/AdminUserComponents/ProviderSchedule/PersonalSchedule';
import MyServices from '../../../Components/AdminUserComponents/Services/MyServices';
import ClinicServicesTabs from '../../../Components/AdminUserComponents/Services/ClinicServicesTabs';
import WareHouseTabs from '../../../Components/InventoryComponents/Warehouse/WareHouseTabs';
import DrugTabs from '../../../Components/InventoryComponents/Drugs/DrugTabs';
import ExercisesTabs from '../../../Components/AdminUserComponents/Exercises/ExercisesTabs';
import Enquiries from '../../../Components/AdminUserComponents/Enquiries/Enquiries';
import WorkOutsTabs from '../../../Components/AdminUserComponents/WorkOuts/WorkOutsTabs';
import BenefitsTabs from '../../../Components/AdminUserComponents/Membership/BenefitsTabs';
import MembershipTabs from '../../../Components/AdminUserComponents/Membership/MembershipTabs';
import DietPlanQuestionnaireTabs from '../../../Components/AdminUserComponents/DietPlanQuestionnaire/DietPlanQuestionnaireTabs';
import ZoomMeeting from '../../../Components/ProviderComponents/AllAppointments/ZoomMeeting';
import MembershipGroupsTabs from '../../../Components/AdminUserComponents/MembershipGroups/MembershipGroupsTabs';
import MessagesUser from '../../../Components/ProviderComponents/ChatSystem/MessagesUser';
import FacilitiesTabs from '../../../Components/AdminUserComponents/Facilities/FacilitiesTabs';


const ProviderRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const navigate = useNavigate();
  const RefreshToken = getDecryptedRefreshToken();
  const timeoutDuration = 30 * 60 * 1000; 

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowDialog(true);
    }, timeoutDuration - 5 * 60 * 1000); 

    const resetTimeout = () => {
      clearTimeout(timeout);
      setShowDialog(false);
    };

    window.addEventListener('click', resetTimeout);
    window.addEventListener('keypress', resetTimeout);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('click', resetTimeout);
      window.removeEventListener('keypress', resetTimeout);
    };
  }, [timeoutDuration]);

  const handleLogout = async () => {
    setLoading(true);
    setTimeout(() => {
      setShowDialog(false);
      sessionStorage.clear();
      navigate('/provider-emr-login');
      setLoading(false);
    }, 3000);
  };


  const handleContinueSession = () => {
    setLoading(true);

    const payload = {
      user_role: "users",
      client_id: process.env.REACT_APP_CLINTID_ACS_TKN,
      scope: process.env.REACT_APP_PROVIDER_SCOPES,
      grant_type: "refresh_token",
      refresh_token: RefreshToken
    };

    ApiServices.post("/oauth2/default/token", payload, {
      "Content-Type": "application/x-www-form-urlencoded",
    })
      .then((response) => {
        console.log("Session Continue data", response);

        const { data } = response;
        const secretKey = process.env.REACT_APP_SECRET_KEY;
        const encryptedAccessToken = CryptoJS.AES.encrypt(
          response.data.access_token,
          secretKey
        ).toString();
        sessionStorage.setItem("LoginUserAccessToken", encryptedAccessToken);
        const encryptedRefreshToken = CryptoJS.AES.encrypt(
          response.data.refresh_token,
          secretKey
        ).toString();
        sessionStorage.setItem("LoginUserRefreshToken", encryptedRefreshToken);
        setShowDialog(false);
      })
      .catch((error) => {
        console.log("Error during session renewal:", error);
        if (error !== null) {
          setSnackbarOpen(true);
          setSnackbarMessage("An error occurred during session renewal.");
          // handleLogout();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

 

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <ProviderSidebar />
      <div style={{ marginLeft: isLargeScreen ? '250px' : '0', flexGrow: 1, padding: "10px" }}>
        <Routes>
          <Route path="/dashboard" element={<ProviderRouteAccess element={<ProviderDashboard />} />}/>
          <Route path="/appointments" element={<ProviderRouteAccess element={<AllAppointments />} />}/>
          <Route path="/patient-list" element={<ProviderRouteAccess element={<PatientTabs />} />}/>
          <Route path="/send-messages" element={<ProviderRouteAccess element={<MessagesUser />} />}/>
          <Route path="/all-doctors" element={<ProviderRouteAccess element={<DoctorDetailsTabs />} />}/>
          <Route path="/my-schedule" element={<ProviderRouteAccess element={<PersonalSchedule />} />}/>
          <Route path="/my-services" element={<ProviderRouteAccess element={<MyServices />} />}/>
          <Route path="/clinic-services" element={<ProviderRouteAccess element={<ClinicServicesTabs />} />}/>
          <Route path="/inventory-handling" element={<ProviderRouteAccess element={<WareHouseTabs />} />}/>
          <Route path="/drugs" element={<ProviderRouteAccess element={<DrugTabs/>} />}/>
          <Route path="/exercises-handling" element={<ProviderRouteAccess element={<ExercisesTabs/>} />}/>
          <Route path="/all-enquiries" element={<ProviderRouteAccess element={<Enquiries/>} />}/>
          <Route path="/all-workouts" element={<ProviderRouteAccess element={<WorkOutsTabs/>} />}/>
          <Route path="/all-benefits" element={<ProviderRouteAccess element={<BenefitsTabs/>} />}/>
          <Route path="/all-membership" element={<ProviderRouteAccess element={<MembershipTabs/>} />}/>
          <Route path="/ai-diet-questions" element={<ProviderRouteAccess element={<DietPlanQuestionnaireTabs/>} />}/>
          <Route path="/membership-groups" element={<ProviderRouteAccess element={<MembershipGroupsTabs/>} />}/>
          <Route path="/facilities" element={<ProviderRouteAccess element={<FacilitiesTabs/>} />}/>
          <Route path="/consultation/:meetid/:pass" element={<ProviderRouteAccess element={<ZoomMeeting/>} />}/>
        </Routes>
      </div>
      <Dialog open={showDialog} 
      onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            event.stopPropagation();
          }
        }}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle>Session Expiring</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your login session is expiring in 5 minutes. Do you want to continue or log out now?
          </DialogContentText>
          {loading && <CircularProgress />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleContinueSession} color="primary" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Continue"} 
          </Button>
          <Button onClick={handleLogout} color="secondary" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Log Out"} 
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="error">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ProviderRoutes;